import { Spinner, SpinnerProps } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useSpinDelay } from "spin-delay";

/**
 * Use this to show a spinner that's delayed for X milliseconds and that shown for minimum duration.
 * This helps showing spinners for requests that are expected to be fulfilled very fast,
 * and also avoids the spinner blinking in and out so fast that you barely register it.
 * For other cases, use `AnimatedSpinner` or Chakra's `Spinner` directly.
 */
export function DelayedSpinner({
  delay = 300,
  minDuration = 200,
  ...spinnerProps
}: {
  delay?: number;
  minDuration?: number;
} & SpinnerProps) {
  const [isLoading, setIsLoading] = useState(false);
  const showSpinner = useSpinDelay(isLoading, { delay, minDuration });

  useEffect(() => {
    setIsLoading(true);
  }, []);

  return showSpinner ? (
    <Spinner aria-busy="true" role="status" {...spinnerProps} />
  ) : null;
}
